import { createReducer, on } from '@ngrx/store';
import { identityCardActions } from '../identity_card.actions';

export interface CiDeleteExtractionState {
    state: 'pending' | 'loading' | 'loaded' | 'error';
}

export const initialState: CiDeleteExtractionState = { state: 'pending' };

export const ciDeleteExtractionReducer = createReducer(
    initialState,
    on(identityCardActions.deleteExtraction, (state) => ({ ...state, state: 'loading' as const })),
    on(identityCardActions.deleteExtractionSuccess, (state) => ({ ...state, state: 'loaded' as const })),
    on(identityCardActions.deleteExtractionFail, (state) => ({ ...state, state: 'error' as const })),
    on(identityCardActions.clearDeleteExtraction, () => initialState)
);
